/**
 * Klaviyo Back-in-Stock Subscription
 * JavaScript part of the subscription form
 * {{ 'sus-back-in-stock-form.js' | asset_url | script_tag }}
 */
(function () {

    const COMPANY_ID = 'VHnckY'; // <- klaviyo public api key
    const ENDPOINT = `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${COMPANY_ID}`;
    const PROFILE_ENDPOINT = `https://a.klaviyo.com/client/profiles?company_id=${COMPANY_ID}`;
    const REVISION = '2026-04-15';
    const STAGE_HOSTNAME_KEYWORDS = ['stage', 'localhost', '127.0.0.1'];
    const STATIC_TEST_VARIANT_ID = '46140839166180'; // <- variant id from live shop (for testing purposes)

    document.querySelectorAll('[data-back-in-stock-form]').forEach((form) => {
        form.addEventListener('submit', async (e) => {

            e.preventDefault();

            if (!form.checkValidity()) {
                form.reportValidity();
                return;
            }

            let variantId = document.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
            let email = form.email.value.trim();
            let messageEl = form.querySelector('[data-back-in-stock-message]');
            let button = form.querySelector('button[type="submit"]');

            if (STAGE_HOSTNAME_KEYWORDS.some((keyword) => location.hostname.includes(keyword))) {
                variantId = STATIC_TEST_VARIANT_ID;
            }

            if (!variantId) {
                showBackInStockMsg(messageEl, backInStockStrings.selectVariant);
                return;
            }

            button.disabled = true;
            showBackInStockMsg(messageEl, backInStockStrings.sending);

            try {
                const res = await fetch(ENDPOINT, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/vnd.api+json',
                        Accept: 'application/vnd.api+json',
                        revision: REVISION,
                    },
                    body: JSON.stringify({
                        data: {
                            type: 'back-in-stock-subscription',
                            attributes: {
                                channels: ['EMAIL'],
                                profile: {data: {type: 'profile', attributes: {email}}},
                            },
                            relationships: {
                                variant: {
                                    data: {type: 'catalog-variant', id: `$shopify:::$default:::${variantId}`},
                                },
                            },
                        },
                    }),
                });

                showBackInStockMsg(
                    messageEl,
                    res.status === 202 ? backInStockStrings.success : backInStockStrings.error,
                    res.status === 202 ? 'sus-message-success' : 'sus-message-error'
                );

                if (res.status === 202) {
                    updateProfileLocale(email, form.dataset.locale);
                    form.reset();
                }

            } catch (err) {
                showBackInStockMsg(messageEl, backInStockStrings.error, 'sus-message-error');
            } finally {
                button.disabled = false;
            }
        });
    });

    function updateProfileLocale(email, locale) {
        if (!locale) return;
        fetch(PROFILE_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/vnd.api+json',
                Accept: 'application/vnd.api+json',
                revision: REVISION,
            },
            body: JSON.stringify({
                data: {
                    type: 'profile',
                    attributes: {
                        email,
                        properties: {back_in_stock_language: locale},
                    },
                },
            }),
        }).catch(() => {
        });
    }

    function showBackInStockMsg(el, text, className = 'success') {
        if (!el) return;
        el.textContent = text;
        el.classList.remove('sus-message-success', 'sus-message-error');
        el.classList.add(className);
        el.classList.remove('hidden');

    }
})();